/* migrated from app/script/component/n-product-card.js */
(() => {
  // app/script/component/n-product-card.js
  var NProductCard = class extends HTMLElement {
    constructor() {
      super();
      this.atc = null;
      this.id = null;
      this.temp = null;
    }
    connectedCallback() {
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => this.initEvents());
      } else {
        this.initEvents();
      }
    }
    initEvents() {
      console.log("initEvents product card");
      this.atc = this.querySelector('button[type="submit"]');
      if (!this.atc) return;
      this.id = parseInt(this.querySelector('input[name="id"]').value);
      this.temp = this.getAttribute("data-prefix");
      this.atc.addEventListener("click", this.handleATC.bind(this));
      this.setLoading(false);
    }
    async handleATC(e) {
      e.preventDefault();
      e.stopPropagation();
      const itemInCart = this.findItemInCart();
      console.log("itemInCart::", itemInCart);
      if (itemInCart) {
        this.handleUpdateAtc(itemInCart);
        return;
      }
      this.setLoading(true);
      const body = {
        id: this.id,
        quantity: 1
      };
      console.log("body::", body);
      const res = await fetch(`${window.routes.cart_add_url}`, {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
          "Content-Type": "application/json"
        }
      });
      if (res.ok) {
        const eventDetail = { source: "n-product-card", variantId: this.id };
        document.dispatchEvent(new CustomEvent("cart:updated", { detail: eventDetail }));
      }
      this.setLoading(false);
    }
    findItemInCart() {
      const cartItems = document.querySelector("cart-items");
      const item = cartItems.querySelector(`input.quantity__input[data-quantity-variant-id="${this.id}"]`);
      return item;
    }
    async handleUpdateAtc(item) {
      try {
        const body = JSON.stringify({
          updates: {
            [this.id]: parseInt(item.value) + 1
          },
          sections: ["main-cart-items"]
        });
        const res = await fetch(`${window.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        if (res.ok) {
          const eventDetail = { source: "n-product-card", variantId: this.id };
          document.dispatchEvent(new CustomEvent("cart:updated", { detail: eventDetail }));
        }
        this.setLoading(false);
      } catch (error) {
        this.setLoading(false);
        console.error(error);
      }
    }
    setLoading(loading) {
      if (this.atc) {
        this.atc.setAttribute("data-loading", loading);
      }
    }
  };
  customElements.define("n-product-card", NProductCard);
})();
